<template>
	<div class="worklist-title py-3">
		<div class="worklist-title mr-9">
			<div>Jobs Worklists </div>
			<v-tooltip v-if="$vuetify.breakpoint.mdAndUp" right max-width="calc(50%)" z-index="11">
				<template v-slot:activator="{ on, attrs }">
					<div class="worklist-title" v-bind="attrs" v-on="on">
						<InfoOutline class="info-icon" />
					</div>
				</template>
				<span>A Jobs worklist is a list of jobs in the database based on a set of search criteria and filters. </span>
			</v-tooltip>
		</div>
		<div class="worklist-title" v-if="$vuetify.breakpoint.mdAndUp">
			<v-checkbox 
				class="mt-0"
				color="light-blue"
				v-model="include_shared_local" 
				label="Include work lists shared with me"
				dense
				hide-details
			/>
			<v-checkbox 
				class="ml-6 mt-0"
				color="light-blue"
				v-model="include_hidden_local" 
				label="Show hidden work lists"
				dense 
				hide-details	
			/>
		</div>
		<v-bottom-sheet v-else>
			<template v-slot:activator="{ on, attrs }">
				<div class="mr-2" v-bind="attrs" v-on="on">
					<FirstList  color="rgba(25, 42, 62, 0.7)" width="20" hight="20"/>
				</div>
			</template>
			<v-sheet class="sheet-panel">
				<div class="sheet-panel-item">
					<div>
						Show lists shared with me
					</div>
					<v-switch
						color="info"
						inset
						v-model="include_shared_local"
					></v-switch>
				</div>
				<div class="sheet-panel-item">
					<div>Show hidden lists</div>
					<v-switch
						color="info"
						inset
						v-model="include_hidden_local"
					></v-switch>
				</div>
			</v-sheet>
		</v-bottom-sheet>
	</div>
</template>
<script>
import InfoOutline from "@/components/icons/info_outline";
import FirstList from "@/components/icons/first_list";

export default {
	name: 'ControlBar',
	props: {
		include_shared: {
			type: Boolean,
			default: true,
		},
		include_hidden: {
			type: Boolean,
			default: false,
		}
	},
	components: {
		InfoOutline, FirstList
	},
	data() {
		return {
			include_shared_local: this.include_shared,
			include_hidden_local: this.include_hidden,
			sheet: false,
		}
	},
	watch: {
		include_shared_local() {
			if (this.include_shared_local !== this.include_shared) {
				this.$emit('include_shared_checkbox', this.include_shared_local);
			}
		},
		include_hidden_local() {
			if (this.include_hidden_local !== this.include_hidden) {
				this.$emit('include_hidden_checkbox', this.include_hidden_local);
			}
		}
	},
}
</script>
<style lang="scss" scoped>
.worklist-title {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}
.info-icon {
	width: 20px;
	height: 20px;
	margin-left: 16px;
}
.sheet-panel {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  padding: 0 28px 0 70px;
  height: 150px;
  background: #FFFFFF;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #192A3E;
  .sheet-panel-item {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }
}
</style>